import ObservablePropertyDescriptorObject from '../utils/ObservablePropertyDescriptorObject';
import PropertyDescriptor from '../utils/PropertyDescriptor';
import ModelDataSourcePropertyBase from "./ModelDataSourcePropertyBase";

export default class Model extends ModelDataSourcePropertyBase {

    name = new PropertyDescriptor(``, "参数名", "基本", "string", "#anticon-ui-text-field-format", {
        description: '请求参数',

        // editable: false,
    });

    expression = new PropertyDescriptor(``, '使用 Javascript 设置参数', "高级", "js", "#anticon-Documentation", {
        description: '请编写 Javascript 表达式，表达式的运算结果将作为请求网络服务的参数值',
        formItemLayout: {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 24 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 24 },
            },
        }
    });

    constructor(opts = {}) {
        super();

        for (var p in opts) {
            this[p].value = opts[p];
        }

        this.defineAllProperties();
    }

    getValue(opts = {}) {
        if (!opts.runScript)
            return null;

        return opts.runScript(this.expression, opts.data, undefined, { data: opts.data, lastData: opts.lastData }, { throwException: true });
    }

    toString() {
        return this.expression ? `${this.name}: ${this.expression}` : `${this.name}`;
    }
}
